<ng-container *ngIf="businesses.length >= 1; else placeholder">
  <app-business-summary *ngFor="let business of sortedFBOs" [business]="business" [fteAwardYear]="fteAwardYear"></app-business-summary>
  <!-- <ng-container *ngIf="sortedFBOs.length > 0"> -->
    <div class="business-listing__business-header">
      <div class="business-listing__business-header-container">
        Flight Training
        <div class="business-listing__add-business"
             *ngIf="!isFlightDeckAdmin"
             (click)="openSubmitNewBusinessDialog('Flight School')">Submit New Flight School
        </div>
      </div>
    </div>
  <!-- </ng-container> -->
  <app-business-summary *ngFor="let business of sortedFlightTraining" [business]="business" [fteAwardYear]="fteAwardYear"></app-business-summary>
  <a href="https://www.aopa.org/training-and-safety/learn-to-fly/flight-schools#t=tagFlightSchools&sort=%40aopaufbusinessname%20ascending"
     target="_blank" class="business-listing__flight-training-finder">Find other flight training opportunities in the AOPA Flight School Directory</a>
  <!-- <ng-container *ngIf="sortedFBOs.length > 0 && sortedBusinesses.length > 0"> -->
    <div class="business-listing__business-header">
      <div class="business-listing__business-header-container">
        Other businesses
        <div class="business-listing__add-business"
             *ngIf="!isFlightDeckAdmin"
             (click)="openSubmitNewBusinessDialog('business')">Submit New Business
        </div>
      </div>
    </div>
  <!-- </ng-container> -->
  <app-business-summary *ngFor="let business of sortedBusinesses" [business]="business" [fteAwardYear]="fteAwardYear"></app-business-summary>
</ng-container>
<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">There are no businesses listed as operating at this airport.</div>
  </div>
</ng-template>
